export default __webpack_public_path__ + "static/media/z630ma0b.b9d45eae.mp3";